import { Columns, Element, Icon } from 'react-bulma-components';
import { FaCheck, FaXmark } from 'react-icons/fa6';
import CorrectScreenResolutionDisplay from '../../../../assets/icons/correct-screen-resolution-display';
import IncorrectScreenResolutionDisplay from '../../../../assets/icons/incorrect-screen-resolution-display';
import Button from '../../button/button';
import Modal from '../../modal/modal';

export type ResolutionScalingWarningModalProps = {
  show: boolean;
  onClose: () => void;
};

export function ResolutionScalingWarningModal({
  show,
  onClose,
}: ResolutionScalingWarningModalProps) {
  return (
    <Modal
      show={show}
      onClose={onClose}
      closeOnBlur
      closeOnEsc
      cardClassName="is-width-60"
      title="Your screen resolution is too small"
    >
      <Columns>
        <Columns.Column>
          <Element renderAs="p" my={4}>
            <span>
              This portal is optimized for screens of at least 1920x1080. You
              are currently working in a smaller resolution. This may be due to
              the resolution scaling set up by your operating system.
            </span>
          </Element>
          <Element renderAs="p" my={4}>
            <span>
              For an optimal experience, please zoom out using Ctrl + “-” or
              Ctrl + Scroll Wheel, or clicking on the 3 dots on the right side
              of the address bar in your browser, and adjusting the zoom level
              manually
            </span>
          </Element>
          <Element renderAs="p" my={4}>
            <span>
              Please feel free to readjust the zoom level if you run into any
              issues while using this portal.
            </span>
          </Element>
        </Columns.Column>
        <Columns.Column
          className="is-one-quarter"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <CorrectScreenResolutionDisplay />
          <Icon color="success-dark" pt={4} pb={8}>
            <FaCheck />
          </Icon>
          <IncorrectScreenResolutionDisplay />
          <Icon color="danger-dark" pt={4}>
            <FaXmark />
          </Icon>
        </Columns.Column>
      </Columns>
      <Element mt={4} display="flex" justifyContent="center">
        <Button color="primary-dark" onClick={onClose}>
          <Icon>
            <FaXmark />
          </Icon>
          <span>Close</span>
        </Button>
      </Element>
    </Modal>
  );
}

export default ResolutionScalingWarningModal;
